<template>
  <portal to="popup-gallery">
    <swiper
      ref="libraryGalleryPopup"
      class="gallerySwiper  gallery-list-popup"
      :class="{ activated: selectedImage }"
      :options="swiperOptionsSecond"
    >
      <swiper-slide v-for="image in images" :key="image.id" class="grab">
        <div class="image-cont">
          <picture>
            <source media="(max-width: 767px)" :srcset="image.devices.mobile" />
            <source
              media="(max-width: 1023px)"
              :srcset="image.devices.tablet"
            />
            <img loading="lazy" :src="image.devices.desktop" alt />
          </picture>
        </div>
      </swiper-slide>
    </swiper>
    <div class="gallery-swiper-nav">
      <div class="gallery-swiper-close" @click="close">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25.457"
          height="25.456"
          viewBox="0 0 25.457 25.456"
        >
          <path
            id="Combined_Shape"
            data-name="Combined Shape"
            d="M8,17V10H1A1,1,0,1,1,1,8H8V1a1,1,0,1,1,2,0V8h7a1,1,0,0,1,0,2H10v7a1,1,0,0,1-2,0Z"
            transform="translate(12.729) rotate(45)"
            fill="#DADADA"
          />
        </svg>
      </div>
      <div class="nav-item nav--prev">
        <svg
          class="arrow arrow2"
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
        >
          <path
            id="Combined_Shape_Copy_2"
            data-name="Combined Shape Copy 2"
            d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
            transform="translate(0 0)"
            fill="#DADADA"
          />
        </svg>
      </div>
      <div class="nav-item nav--next">
        <svg
          class="arrow arrow2"
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
        >
          <path
            id="Combined_Shape_Copy_2"
            data-name="Combined Shape Copy 2"
            d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
            transform="translate(0 0)"
            fill="#DADADA"
          />
        </svg>
      </div>
    </div>
    <div
      @click="close"
      :class="{ activated: selectedImage }"
      class="background-dark"
    ></div>
  </portal>
</template>
<script>
export default {
  props: ["images", "pupupData", "clickedIndex", "imageId"],
  data() {
    return {
      selectedImage: false,
      clickedIndexItem: 0,
      swiperOptionsSecond: {
        speed: 800,
        slidesPerView: 1,
        navigation: {
          nextEl: ".nav--prev",
          prevEl: ".nav--next"
        },
        on: {
          touchMove() {
            document
              .querySelectorAll(".gallery-list-popup .swiper-slide")
              .forEach(slide => {
                slide.style.transform = "scale(0.85, 0.85)";
              });
          },
          touchEnd() {
            document
              .querySelectorAll(".gallery-list-popup .swiper-slide")
              .forEach(slide => {
                slide.style.transform = "scale(1, 1)";
              });
          }
        }
      }
    };
  },
  watch: {
    clickedIndex: {
      handler(val) {
        this.clickedIndexItem = val;
        setTimeout(() => {
          this.swiperPopup.slideTo(this.clickedIndexItem);
        }, 200);
      }
    },
    imageId: {
      handler(val) {
        setTimeout(() => {
          this.selectedImage = val;
        }, 500);
      }
    }
  },
  computed: {
    swiperPopup() {
      return this.$refs.libraryGalleryPopup
        ? this.$refs.libraryGalleryPopup.$swiper
        : "";
    }
  },
  methods: {
    close() {
      this.selectedImage = false;
      this.clickedIndexItem = 0;

      this.$emit("close");
    }
  }
};
</script>
<style scoped>
.swiper-container.gallery-list {
  padding-bottom: 55px;
}
.swiper-scrollbar {
  background-color: #dadada;
  height: 3px !important;
  transform: translate(-50%, -50%);
  position: absolute;
  left: 50%;
}
body[data-theme="night"] .swiper-scrollbar {
  background-color: #555555;
}
.swiper-scrollbar-drag {
  top: -1px;
  background: linear-gradient(
    to right,
    #26dffe 0%,
    #21cdf5 30%,
    #0dbff4 75%,
    #00aeef 100%
  );
  height: 5px;
  cursor: pointer;
}
.image-cont {
  position: relative;
  height: 610px;
  transition: 0.6s;
}
.image-cont img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-cont:hover .hover-symbol {
  opacity: 1;
  visibility: visible;
}

.hover-symbol {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  right: 60px;
  bottom: 66px;
  transition: 0.6s;
}

.gallery-list {
  transition: 0.6s ease;
}
.gallery-list-popup.activated {
  opacity: 1;
  visibility: visible;
}
.gallery-list-popup {
  opacity: 0;
  visibility: hidden;
  transition: 0.6s;
}
.gallerySwiper {
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
.gallerySwiper:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
/* .gallery-swiper-nav {
  position: absolute;
  z-index: 99999999999;
} */
.gallery-swiper-nav .nav--next {
  left: 5%;
}
.gallery-swiper-nav .nav--next svg {
  transform: rotate(180deg);
}
.gallerySwiper.gallery-list-popup.activated
  + .gallery-swiper-nav
  .gallery-swiper-close {
  opacity: 1;
  visibility: visible;
}
.gallery-swiper-close {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  width: 36px;
  height: 36px;
  z-index: 99999;
  right: 5%;
  top: 5%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #dadada;
  cursor: pointer;
  transition: 0.3s;
}
.gallery-swiper-nav .nav-item {
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
  position: absolute;
  transform: translate(50%, -50%);
  z-index: 99999;
  top: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #dadada;
  cursor: pointer;
}
.gallery-swiper-nav .nav--prev {
  right: 6%;
}
.gallerySwiper.gallery-list-popup.activated + .gallery-swiper-nav .nav-item {
  opacity: 1;
  visibility: visible;
}
.gallerySwiper.gallery-list-popup.activated .image-cont img {
  object-fit: contain;
}
@media (max-width: 1025px) {
  .gallery-swiper-close {
    position: fixed;
    top: 10%;
  }
  .gallery-swiper-nav .nav-item {
    position: fixed;
    transform: translate(20%, -50%);
  }
}
@media (max-width: 767px) {
  .gallery-swiper-nav .nav--next {
    left: 10px;
  }
  .gallery-swiper-nav {
    position: absolute;
    z-index: 99999999999;
  }
  .gallery-swiper-nav .nav--prev {
    right: 25px;
  }
}
</style>

<style>
.hide-scroll {
  overflow: hidden;
}
.gallery-list-popup {
  display: none;
  width: 80%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /*max-width: 1500px;*/
}
.gallery-list-popup.activated {
  display: block;
  position: fixed;
  z-index: 99999999999;
}
.gallery-list-popup.activated .image-cont {
  height: 85vh;
}

.libraryGallery .swiper-slide.fade-opacity .image-cont {
  opacity: 0.3;
}
.swiper-slide.not-active .image-cont,
.swiper-slide.active-hover .image-cont {
  opacity: 1;
}
.background-dark.activated {
  opacity: 1;
  visibility: visible;
}
.background-dark {
  opacity: 0;
  visibility: hidden;
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 9999;
  transition: 0.6s;
  background: rgba(0, 0, 0, 0.5);
}
.gallerySwiper .swiper-slide {
  transition: transform 0.6s ease;
}
@media (max-width: 767px) {
  .image-cont {
    height: 330px !important;
  }
}
</style>
